// import axios from "axios";
import { getAccessToken } from "lib/accessToken";
import { getFromLocalStorage } from "lib/common/helper/LocalStorage";
import React, { useCallback, useEffect, useState } from "react";
import { host } from "utils/constants";
import { message as _message } from "antd";
import myaxios from "lib/myAxios";

function useFormDataInput() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (error) {
      _message?.error(error?.message ?? "Upload failed. Please check your file and try again.");
    } else if (message) {
      _message?.success(message);
    }
  }, [error, message]);

  const reqWithFormData = useCallback(
    (operation = "post", route, value, bearer: boolean = false) => {
      setLoading(true);
      setError(null);
      setMessage("");
      const headers = bearer
        ? {
            Authorization: `Bearer ${getAccessToken()}`,
            "Content-Type": "multipart/form-data",
          }
        : {
            "Content-Type": "multipart/form-data",
            Authorization: "null",
          };

      myaxios({
        method: operation,
        url: host + route,
        headers: headers,
        data: value,
      })
        .then(({ data: { data, success, message } }) => {
          setSuccess(success);
          setMessage(message);
        })
        .catch((err) => {
          setError(err.response.data);
        })
        .finally(() => setLoading(false));
    },
    []
  );

  return { reqWithFormData, loading, error, success };
}

export default useFormDataInput;
